export const ENDPOINTS = {
    CHURCHES_SEARCH: '/groups/giao-hat/{key}/giao-xu/search'
}
